<template>
  <div class="box5_main">
    <div class="title">智能井盖</div>
    <div class="content">
      <div class="main_img"><img src="@/assets/home_images/box5/main.png"></div>
      <div class="con_box">
        <div class="con_line">
          <div class="con_one"><span>{{itemData.total}}</span>设备数量</div>
          <div class="con_one"><span>{{itemData.warning}}</span>报警条数</div>
        </div>
        <div class="con_line">
          <div class="con_one"><span>{{itemData.online}}</span>在线数量</div>
          <div class="con_one"><span>{{itemData.Offline}}</span>离线数量</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Box5',
  props: {
    itemData: {
      type: Object,
      required: true, // 默认值是false
      default: function () {
        return {
          total: 0,
          warning:0,
          online: 0,
          Offline: 0
        }
      }
    }
  },
  data() {
    return {
    }
  }
};
</script>
<style lang='less' scoped>
.box5_main {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  flex-direction: column;
  .title {
    font-size: 18px;
    line-height:30px;
    font-weight: normal;
    color:#fff;
    display: block;
    width:100%;
  }
  .content{
    position: absolute;
    padding-top:30px;
    width:100%;
    height:100%;
    box-sizing: border-box;
    top:0;
    left:0;
    .main_img{
      float: left;
      width:42%;
      height:100%;
      text-align: center;
      img{
        width:auto;
        height:100%;
      }
    }
    .con_box{
      float: right;
      width:50%;
      height:100%;
      .con_line{
        width:100%;
        height:50%;
        display: flex;
        justify-content: space-between;
        align-items: center; 
        .con_one{
          color:#fff;
          font-size:12px;
          span{
            display: block;
            color:#00a99d;
            font-size:32px;
            text-align: center;
            font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
            font-style: normal;
          }
        }
        
      }
    }
    
  }
  
}


</style>